import { Center, Group, Table } from "@mantine/core";

import { IconFileInvoice } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

import { EMPTY_MESSAGE, OPEN_STATEMENTS_COLUMN_SPAN } from "./constants/open-statements";

interface OpenStatementsEmptyStateProps {
  message?: string;
}

export default function OpenStatementsEmptyState({
  message = EMPTY_MESSAGE,
}: OpenStatementsEmptyStateProps) {
  return (
    <Table.Tr>
      <Table.Td colSpan={OPEN_STATEMENTS_COLUMN_SPAN}>
        <Center py="xs" w="100%" bg="gray.1" style={{ borderRadius: "var(--mantine-radius-sm)" }}>
          <Group gap="xs" align="center" justify="center">
            <IconFileInvoice size={18} color="var(--mantine-color-gray-6)" />
            <TextWrapper c="gray.7" data-testid="open-statements-table-empty">
              {message}
            </TextWrapper>
          </Group>
        </Center>
      </Table.Td>
    </Table.Tr>
  );
}
